import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment as env } from '../../../environments/environment';
import { switchMap } from 'rxjs/operators';
import { User } from './user.model';
import { Installer } from './installer.model';



@Injectable({
    providedIn: 'root'
})
export class UserService
{
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);
    private _installer: ReplaySubject<Installer> = new ReplaySubject<Installer>(1);
    private _basePath = env.url + env.api_sell;
    private _baseinstPath = env.url + env.api_inst;

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient)
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User)
    {
        // Store the value
        this._user.next(value);
    }

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set installer(value: Installer)
    {
        // Store the value
        this._installer.next(value);
    }

    get user$(): Observable<User>
    {
        return this._user.asObservable();
    }

    get installer$(): Observable<Installer>
    {
        return this._installer.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * get the user details
     *
     */
    getUserDetails(): Observable<any> {
        return this._httpClient.get(this._basePath + 'auth/sellers/me').pipe(
            catchError((err:any) =>

                // Return false
                of(false)
            ),
            switchMap((response: any) => {

                // Return a new observable with the response
                // this._user.next(response[0]);
                this.user=response
                return of(response);
            }));
    }

    /**
     * get the installer details
     *
     */
    getInstallerDetail(): Observable<any> {
        return this._httpClient.get(this._baseinstPath + 'auth/login/complete/?device_id=NOT_PROVIDED').pipe(
            catchError((err:any) =>

                // Return false
                of(false)
            ),
            switchMap((response: any) => {

                // Return a new observable with the response
                // this._user.next(response[0]);
                this.installer=response
                return of(response);
            }));
    }

    /**
     * Update the user
     *
     * @param user
     */
    update(user: User): Observable<any>
    {
        return this._httpClient.patch<User>('api/common/user', {user}).pipe(
            map((response) => {
                // Execute the observable
                this._user.next(response);
            })
        );
    }
}
